import React, { useContext, useState, useEffect } from "react";
import { USER_ORG_ID } from "../../queries";
import { useLazyQuery } from "@apollo/client";
import jwtDecode from "jwt-decode";
import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

// コンテキストオブジェクト
const LoginStatusContext = React.createContext();
const MyOrgInfoContext = React.createContext();
const UserInfoContext = React.createContext();
const UserRoleContext = React.createContext();
const UserEmailContext = React.createContext();
const OrgPkContext = React.createContext();
const OrgContractContext = React.createContext();

// コンテキストの値取得用関数
// ログイン状態=>IDを返す e.g.#35dbadavb35s==
export function useLoginStatus() {
  return useContext(LoginStatusContext);
}
// 自団体の基本情報を返す e.g. ID, pk, name
export function useMyOrgInfo() {
  return useContext(MyOrgInfoContext);
}
// ユーザーの基本情報を返す
export function useUserInfo() {
  return useContext(UserInfoContext);
}
// ユーザーのロールを返す
export function useUserRole() {
  return useContext(UserRoleContext);
}
export function useUserEmail() {
  return useContext(UserEmailContext);
}
// 団体のpkを返す
export function useOrgPk() {
  return useContext(OrgPkContext);
}

// プロバイダーコンポーネント
export function LoginStatusProvider({ children }) {
  const [orgId, setOrgId] = useState("");
  const [myOrgInfo, setMyOrgInfo] = useState("");
  const [userRole, setUserRoleId] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const [email, setEmail] = useState("");
  const [isFirst, setIsFirst] = useState(true);
  const [load, { called, loading, data, error }] = useLazyQuery(USER_ORG_ID, {
    variables: { email: email },
  });

  useEffect(() => {
    if (isFirst) {
      console.log("Reset Root Info");
      // 1. JWTトークン取得
      if (localStorage.getItem("token")) {
        const decodedToken = jwtDecode(localStorage.getItem("token"));

        // 2. JWT期限検証
        if (decodedToken.exp * 1000 < Date.now()) {
          localStorage.removeItem("token");

          // 2-2. 期限が切れてなければ
        } else {
          setEmail(decodedToken.email);
          load();
          setIsFirst(!isFirst);

          // ローディング
          if (loading)
            return (
              <div className="loading__wrapper">
                <img
                  style={{ width: "80px", margin: "auto" }}
                  src={animetionLogo}
                ></img>
              </div>
            );
          if (error) return "...Error";
          // if (!data) return "...Not Found";
        }
      }
    }
  }, []);

  if (myOrgInfo) {
  } else {
    data &&
      data.allUsers &&
      data.allUsers.edges &&
      data.allUsers.edges[0] &&
      data.allUsers.edges[0].node &&
      data.allUsers.edges[0].node.role &&
      data.allUsers.edges[0].node.role.edges[0] &&
      data.allUsers.edges[0].node.role.edges[0].node &&
      setMyOrgInfo(data.allUsers.edges[0].node.role.edges[0].node.organization);
  }

  if (orgId) {
  } else {
    data &&
      data.allUsers &&
      data.allUsers.edges &&
      data.allUsers.edges[0] &&
      data.allUsers.edges[0].node &&
      data.allUsers.edges[0].node.orgId &&
      setOrgId(data.allUsers.edges[0].node.orgId);
  }

  if (userInfo) {
  } else {
    data &&
      data.allUsers &&
      data.allUsers.edges &&
      data.allUsers.edges[0] &&
      setUserInfo(data.allUsers.edges[0].node);
  }

  if (loginStatus) {
  } else {
    data &&
      data.allUsers &&
      data.allUsers.edges &&
      data.allUsers.edges[0] &&
      data.allUsers.edges[0].node &&
      data.allUsers.edges[0].node.id &&
      setLoginStatus(data.allUsers.edges[0].node.id);
  }

  return (
    <LoginStatusContext.Provider value={loginStatus}>
      <MyOrgInfoContext.Provider value={myOrgInfo}>
        <UserInfoContext.Provider value={userInfo}>
          <UserEmailContext.Provider value={email}>
            <OrgPkContext.Provider value={orgId}>
              {children}
            </OrgPkContext.Provider>
          </UserEmailContext.Provider>
        </UserInfoContext.Provider>
      </MyOrgInfoContext.Provider>
    </LoginStatusContext.Provider>
  );
}
